/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// Se preserva el sufijo cruzado del legacy: "_flor" controla pixelsFLOR (pin 5) y "_clear_flor" apaga
// el reflector (pixels, pin 6). El código generado es correcto para el hardware ya desplegado; solo
// el nombre del tipo está cruzado. No renombrar.

Blockly.Blocks.ARDUINOUNO_servo_move_flor = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Floralis.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN')
      .appendField('el pétalo')
      .appendField(new Blockly.FieldDropdown([['1', '1'], ['2 a 6', '2']]), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_MOVE_TOOLTIP);
  },
};

// "de la flor" (label) — controla pixelsFLOR/pin 5, ver nota de arriba.
Blockly.Blocks.BHOOT_led_neopixel_flor = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Floralis.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField('con intensidad');
    this.appendValueInput('DATOIN');
    this.appendDummyInput('').appendField('de la flor').setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

// "en el reflector" (label + dropdown 1-6) — controla pixels/pin 6, ver nota de arriba.
Blockly.Blocks.BHOOT_led_neopixel_flor2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Reflector.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField('con intensidad');
    this.appendValueInput('DATOIN');
    this.appendDummyInput('')
      .appendField('en el reflector')
      .appendField(new Blockly.FieldDropdown([
        ['1', '0'], ['2', '1'], ['3', '2'], ['4', '3'], ['5', '4'], ['6', '5'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

// "Apagar el reflector" — apaga pixels/pin 6 (el strip de BHOOT_led_neopixel_flor2).
Blockly.Blocks.BHOOT_led_neopixel_clear_flor = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Reflector.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField('Apagar el reflector');
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        ['1', '0'], ['2', '1'], ['3', '2'], ['4', '3'], ['5', '4'], ['6', '5'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

// "Apagar las luces de la flor" — apaga pixelsFLOR/pin 5 (el strip de BHOOT_led_neopixel_flor).
Blockly.Blocks.BHOOT_led_neopixel_clear_flor2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Floralis.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField('Apagar las luces de la flor');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};
